import { ReactPropertiesCodeBlockProps } from './types'
import IsInEditorText from '../shared/IsInEditorText'

const ReactPropertiesCodeBlock = (props: ReactPropertiesCodeBlockProps) => {
  const { isInEditor = false } = props
  return (
    <>
      {IsInEditorText(isInEditor, 'React Properties Code Block')}
      <div data-testid={`react-properties-text`} className={`react-properties-text`}></div>
    </>
  )
}
export default ReactPropertiesCodeBlock
